import { render, staticRenderFns } from "./Menref.vue?vue&type=template&id=565d88de&scoped=true&"
import script from "./Menref.vue?vue&type=script&lang=js&"
export * from "./Menref.vue?vue&type=script&lang=js&"
import style0 from "./Menref.vue?vue&type=style&index=0&id=565d88de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565d88de",
  null
  
)

export default component.exports